<template>
  <!-- Error boundary catches config validation errors and shows user-friendly message -->
  <ConfigErrorBoundary>
    <FileConverter
      :config="converterConfig"
      @batch-created="handleBatchCreated"
      @job-completed="handleJobCompleted"
      @batch-cleared="handleBatchCleared"
      @error="handleError"
      @credits-updated="handleCreditsUpdated"
    >
    </FileConverter>
  </ConfigErrorBoundary>
</template>

<script setup lang="ts">
import FileConverter from './FileConverter.vue';
import ConfigErrorBoundary from './ConfigErrorBoundary.vue';
import { parseAndValidateConverterConfig } from '../utils/ConfigValidator';

const converterConfig = parseAndValidateConverterConfig('otf-to-woff-converter', 'OTF → WOFF');

function handleBatchCreated(batchId: string) {
  console.log('[OTF-to-WOFF Converter] Batch created:', batchId);
}

function handleJobCompleted(jobId: string) {
  console.log('[OTF-to-WOFF Converter] Job completed:', jobId);
}

function handleBatchCleared() {
  console.log('[OTF-to-WOFF Converter] Batch cleared');
}

function handleError(error: Error) {
  console.error('[OTF-to-WOFF Converter] Error:', error);
}

function handleCreditsUpdated(credits: number) {
  console.log('[OTF-to-WOFF Converter] Credits updated:', credits);
}
</script>
